import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { CellErrorTypes, TooltipText } from '../CellRenderers';
import styles from './styles.scss';
export var Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.apply(this, arguments);

    _this.text = function () {
      if (_this.props.value.slice(_this.props.value.length - 3) === '...') return TooltipText.TruncatedNumber;

      switch (_this.props.value) {
        case CellErrorTypes.ZeroDivision:
          return TooltipText.ZeroDivision;

        case CellErrorTypes.InvalidDate:
          return TooltipText.InvalidDate;

        case CellErrorTypes.UnexpectedValue:
          return TooltipText.UnexpectedValue;

        default:
          return TooltipText.ClickForMoreActions;
      }
    };

    return _this;
  }

  _createClass(Tooltip, [{
    key: "getReactContainerClasses",
    value: function getReactContainerClasses() {
      return [styles.tooltipWrapper];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          api = _this$props.api,
          rowIndex = _this$props.rowIndex,
          isDetailTable = _this$props.isDetailTable;
      var data = api && api.getDisplayedRowAtIndex ? api.getDisplayedRowAtIndex(rowIndex).data : {};
      return React.createElement("div", {
        className: styles.tooltip
      }, isDetailTable ? this.text() : data.name);
    }
  }]);

  return Tooltip;
}(Component);